import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { MenuTiles, OptionTiles } from './JobTiles';

/**
 * 메뉴·옵션 선택 + 사이즈별 가격 표시 공통 블록.
 * 현장 접수(AddServiceRecord)와 예약 모달(ReservationModal)이 공유한다.
 *
 * 워크보드(WorkboardPage)는 wf-* 자체 디자인 언어(래퍼·라벨)를 쓰므로 이 컴포넌트를
 * 쓰지 않고 JobTiles 만 직접 가져다 쓴다 — 타일 모양은 세 폼이 동일하다.
 *
 * value/onChange 는 { service_menu_id, optionIds } 형태로 통일한다.
 *   - optionIds 는 서버·DB 와 동일한 id 배열. 객체 배열을 쓰지 않는다.
 */
const JobServiceFields = ({
    menus = [],
    options = [],
    prices,
    sizeId,
    value,
    onChange,
    menuInvalid = false,
    compact = false,
}) => {
    const groupedOptions = useMemo(() => {
        const groups = {};
        options.forEach(option => {
            const type = option.type || '기타';
            if (!groups[type]) groups[type] = [];
            groups[type].push(option);
        });
        return groups;
    }, [options]);

    const optionIds = value?.optionIds || [];
    const labelClass = compact ? 'small fw-bold' : 'fw-bold';

    const toggleOption = (optionId) => {
        onChange({
            optionIds: optionIds.includes(optionId)
                ? optionIds.filter(id => id !== optionId)
                : [...optionIds, optionId]
        });
    };

    return (
        <>
            <Form.Group className="mb-4">
                <Form.Label className={labelClass}>메뉴 선택</Form.Label>
                <MenuTiles
                    menus={menus}
                    prices={prices}
                    sizeId={sizeId}
                    selectedId={value?.service_menu_id}
                    onSelect={(id) => onChange({ service_menu_id: id })}
                    invalid={menuInvalid}
                />
            </Form.Group>

            {options.length > 0 && (
                <Form.Group className="mb-4">
                    <Form.Label className={labelClass}>옵션 선택</Form.Label>
                    {Object.keys(groupedOptions).map(type => (
                        <div key={type} className="mb-3">
                            <small className="text-muted d-block mb-2 fw-bold">{type}</small>
                            <OptionTiles
                                options={groupedOptions[type]}
                                prices={prices}
                                sizeId={sizeId}
                                selectedIds={optionIds}
                                onToggle={toggleOption}
                            />
                        </div>
                    ))}
                </Form.Group>
            )}
        </>
    );
};

export default JobServiceFields;
